_areEnabled